import React from 'react';
import { Badge, Group, Text } from '@mantine/core';

const CELLS = {
	used: {
		label: 'Sí',
		title: 'Usado',
		background: '#0f766e',
		color: '#ffffff',
		border: '1px solid #0f766e',
	},
	unused: {
		label: 'No',
		title: 'No usado',
		background: '#e2e8f0',
		color: '#0f172a',
		border: '1px solid #94a3b8',
	},
	missing: {
		label: '—',
		title: 'Sin dato',
		background: '#ffedd5',
		color: '#9a3412',
		border: '1px solid #f97316',
	},
};

export function usedBadgeProps(value) {
	if (value === true) {
		return CELLS.used;
	}
	if (value === false) {
		return CELLS.unused;
	}
	return CELLS.missing;
}

export function UsedBadge({ value }) {
	const cell = usedBadgeProps(value);
	return (
		<Badge
			size='sm'
			radius='sm'
			variant='filled'
			title={cell.title}
			aria-label={cell.title}
			styles={{
				root: {
					minWidth: 44,
					textTransform: 'none',
					fontWeight: 700,
					letterSpacing: '0.02em',
					backgroundColor: cell.background,
					color: cell.color,
					border: cell.border,
				},
			}}
		>
			{cell.label}
		</Badge>
	);
}

export function UsedLegend() {
	return (
		<Group spacing='xs' className='mb-2' align='center'>
			<Text size='sm' color='dimmed'>
				Leyenda
			</Text>
			<UsedBadge value={true} />
			<UsedBadge value={false} />
			<UsedBadge value={undefined} />
		</Group>
	);
}
